import styled from 'styled-components';
import { getScrollBarStyles } from '../../../config/styles';

export const Container = styled.div`
  padding-top: 12px;
  padding-right: 6px;
  padding-left: 12px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding-right: 6px;
  max-height: 480px;
  overflow-y: auto;
  ${getScrollBarStyles(4)}
`;

export const LogicOpContainer = styled.div`
  text-align: center;
`;

export const ActionsContainer = styled.div`
  padding-top: 12px;
  padding-right: 12px;
  padding-left: 12px;
`;
